<template>
  <div class="columns mgt-5px level">
    <div class="column is-12">
      <div class="level-right columns">
        <div class="column is-2" v-for="(faceInfo, index) in facesInformations" :key="index">
          <div class="card">
            <div class="card-content pd-10px">
              <p class="has-text-default"> {{ faceInfo.title }} </p>
              <p class="has-text-link has-text-weight-bold"> {{ faceInfo.nb }} </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    ordresTravail: {
      type: Array,
      required: true,
    },
  },
  computed: {
    facesInformations() {
      return [
        {
          title: this.$i18n.t('listeOrdreTravailAffichage.faces.prevues'),
          nb: this.nFacesPrevues,
        },
        {
          title: this.$i18n.t('listeOrdreTravailAffichage.faces.aAfficher'),
          nb: this.nFacesAffichees,
        },
        {
          title: this.$i18n.t('listeOrdreTravailAffichage.faces.laisserEnPlace'),
          nb: this.nFacesLaisserEnPlace,
        },
        {
          title: this.$i18n.t('listeOrdreTravailAffichage.faces.gratter'),
          nb: this.nGrattageEffectues,
        },
      ];
    },
    nFacesPrevues() {
      const total = this.ordresTravail
        .map(ot => ot.nFacesPrevues)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    nFacesAffichees() {
      const total = this.ordresTravail
        .map(ot => ot.nFacesAffichees)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    nGrattageEffectues() {
      const total = this.ordresTravail
        .map(ot => ot.nGrattageEffectues)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    nFacesLaisserEnPlace() {
      const total = this.ordresTravail
        .map(ot => ot.nFacesLaisserEnPlace)
        .reduce((a, b) => a + b, 0);
      return total;
    },
  },
};

</script>
